export { default as FlagVi } from './flag-vi.svg';
export { default as FlagUK } from './flag-uk.svg';
export { default as FlagKor } from './flag-kor.svg';
export { default as CategoriesSVG } from './categories.svg';
export { default as NotificationSVG } from './notification.svg';
export { default as ClockSVG } from './clock.svg';
export { default as FacebookSVG } from './facebook.svg';
export { default as MaceSVG } from './mace.svg';
export { default as OrderSVG } from './order.svg';
export { default as RoundEllipsisSVG } from './round-ellipsis.svg';
export { default as LogoSVG } from './logo.svg';
export { default as AlarmSVG } from './alarm.svg';
export { default as BoardSVG } from './board.svg';
export { default as CalendarSVG } from './calendar.svg';
export { default as ChartSVG } from './chart.svg';
export { default as FeedbackSVG } from './feedback.svg';
export { default as HelpSVG } from './help.svg';
export { default as InfoSVG } from './info.svg';
export { default as Info1SVG } from './infoIcon.svg';
export { default as QuickOrderSVG } from './quick-order.svg';
export { default as SettingSVG } from './setting.svg';
export { default as UtilitySVG } from './utility.svg';
export { default as TrashSVG } from './trash.svg';
export { default as PauseSVG } from './pause.svg';
export { default as PenSVG } from './pen.svg';
export { default as LinesSVG } from './lines.svg';
export { default as TimeSVG } from './time.svg';
export { default as FilterSVG } from './filter.svg';
export { default as QtySVG } from './qty.svg';
export { default as QuestionMarkSVG } from './question-mark.svg';
export { default as DatabaseSVG } from './database.svg';
export { default as DollarSVG } from './dollar.svg';
export { default as PercentageSVG } from './percentage.svg';
export { default as PhoneCall } from './phoneCall.svg';
export { default as Email } from './email.svg';
export { default as CmndFront } from './cmnd_front.svg';
export { default as CmndBack } from './cmnd_back.svg';
export { default as CmndConner } from './cmnd_conner.svg';
export { default as CmndBlur } from './cmnd_blur.svg';
export { default as CloseRed } from './close_red.svg';
export { default as Step1 } from './step1.svg';
export { default as Step2 } from './step2.svg';
export { default as Step3 } from './step3.svg';
export { default as Step4 } from './step4.svg';
export { default as Step5 } from './step5.svg';
export { default as FailIcon } from './failIcon.svg';
export { default as LogoutIcon } from './Logout.svg';
export { default as AccountUserIcon } from './Acc.svg';
export { default as AccountUserMenuIcon } from './Acc2.svg';
export { default as ChangePWIcon } from './ChangePW.svg';
export { default as UserProfile } from './UserProfile.svg';
export { default as PlaceOrderBtn } from './placeOrderBtn.svg';
export { default as OrderBookSVG } from './orderBook.svg';
export { default as AssetInfomationSVG } from './Asset.svg';
export { default as PortfolioSVG } from './Portfolio.svg';

export { default as OrderSVGUnactive } from './order_unactive.svg';
export { default as OrderBookSVGUnactive } from './orderBook_unactive.svg';
export { default as AssetInfomationSVGUnactive } from './Asset_unactive.svg';
export { default as PortfolioSVGUnactive } from './Portfolio_unactive.svg';
export { default as BoardSVGUnactive } from './board_unactive.svg';
export { default as InfoSVGUnactive } from './info_unactive.svg';
export { default as QuickOrderSVGUnactive } from './quick-order_unactive.svg';
export { default as CloseNew } from './CloseNew.svg';
export { default as InfoBuyIn } from './info_buyin.svg';
export { default as Refresh } from './refresh.svg';
export { default as Clock1 } from './clock1.svg';
export { default as PolicyBanner } from './policy-banner.svg';
export { default as WarningTransfer } from './warning_transfer.svg';



// WEBPACK FOOTER //
// ./src/assets/svg/index.ts